import { Injectable, Inject } from "@angular/core";
import { HttpService, URI } from "../shared/http.service";
import { MasterData } from "./types";
import { HttpHeaders } from "@angular/common/http";

@Injectable()
export class MasterHttpService {
  constructor(private httpService: HttpService) { }
  
  public get() {
    return this.httpService.get<MasterData>(URI`/api/master`);
  }
  
  public getComponents() {
    return this.httpService.get<unknown>(URI`/api/master/components`);
  }
  
  public getMaterials() {
    return this.httpService.get<unknown>(URI`/api/master/materials`);
  }
}